import { useLocation, useParams } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { CollectorInvoice } from './CollectorInvoice'
import { MultiPayments } from './MultiPayments'
import { PaymentInvoice } from './PaymentInvoice'
import { SinglePayment } from './SinglePayment'

export const PaymentsCnt = () => {
  const params = useParams({ strict: false }) as { paymentId?: string, contractId?: string, collectorId?: string }
  const location = useLocation()
  const [jobId, setJobId] = useState<string | null>(new URLSearchParams(location.search as Record<string, string>).get('jobId'))

  useEffect(() => {
    const currentJobId = new URLSearchParams(location.search as Record<string, string>).get('jobId')
    setJobId(currentJobId)
  }, [location.search])

  if (params.paymentId && params.contractId && !jobId) {
    return <SinglePayment paymentId={params.paymentId} contractId={params.contractId} />
  }
  else if (params.paymentId && !jobId) {
    return <MultiPayments paymentId={params.paymentId} />
  }
  else if (params.paymentId && jobId) {
    return <PaymentInvoice paymentId={params.paymentId} jobId={jobId} />
  }
  else if (params.collectorId && jobId) {
    return <CollectorInvoice collectorId={params.collectorId} jobId={jobId} />
  }

  return <>Error</>
}
